import React, { useContext } from 'react';

import ConnectSection from '../components/Sections/ConnectSection';
import { ApiContext } from '../context/api/apiContext';

import ScheduleIcon from '../i/icons/schedule_icon.svg';
import StreamIcon from '../i/icons/stream_icon.svg';
import MonetizeIcon from '../i/icons/monetize_icon.svg';

export const Producers = () => {
	const { jsonData } = useContext(ApiContext);

	const {
		heroSection,
		streamSection,
		supportStreamSectionSection,
		connectSection,
	} = jsonData.pages.producers;

	return (
		<React.Fragment>
			<section className="section hero_v1_mod center_level_mod bottom_decor_mod">
				<div className="section_bg loaded_mod" style={{ backgroundImage: `url(${heroSection.bgImage})` }} />
				<div className="section_in inner_hero_mod">
					<h2 className="section_title center_level_mod hero_v1_mod">{heroSection.title}</h2>
					<div className="section_descr hero_mod center_mod darken_mod">
						{heroSection.description}
					</div>
				</div>
			</section>
			<section className="section">
				<div className="section_in limit_mod">
					<div className="content_banner left_mod">
						<div className="content_banner_img_w">
							<img className="content_banner_img" src={streamSection.contentImg} alt={streamSection.contentImgAlt} />
						</div>
						<div className="content_banner_text_w">
							<h2 className="section_title accent_mod height_mod offset_mod">{streamSection.title}</h2>
							<h3 className="section_subtitle accent_mod">{streamSection.subtitle}</h3>
							<div className="section_descr accent_mod height_mod offset_v3_mod">{streamSection.description}</div>
							<ul className="content_info_list">
								{streamSection.iconsList.map(({ title }, index) => {
									const iconsMod = ['schedule_icon_mod', 'stream_icon_mod', 'monetize_icon_mod'];
									const icons = [<ScheduleIcon />, <StreamIcon />, <MonetizeIcon />];

									return (
										<li className="content_info_item" key={index}>
											<div className="content_info_item_top">
												<span className={`icon_w ${iconsMod[index]}`}>
													{icons[index]}
												</span>
											</div>
											<span className="content_info_item_title">{title}</span>
										</li>
									);

								})}
							</ul>
						</div>
					</div>
				</div>
			</section>
			<section className="section">
				<div className="section_in">
					<ul className="category_list">
						{streamSection.categoryList.map(({ url, title, img, description }, index) => {
							return (
								<li className="category_list_item" key={index}>
									<a className="category_block" href={url}>
										<div className="category_block_w_img">
											<img className="category_block_img" src={img} alt={title} />
										</div>
										<h3 className="category_block_title">{title}</h3>
										<div className="category_block_descr">
											<p>{description}</p>
										</div>
									</a>
								</li>
							)
						})}
					</ul>
				</div>
			</section>
			<section className="section">
				<div className="section_in limit_mod">
					<div className="content_banner">
						<div className="content_banner_img_w">
							<img className="content_banner_img" src={supportStreamSectionSection.contentImg} alt={supportStreamSectionSection.contentImgAlt} />
						</div>
						<div className="content_banner_text_w">
							<h2 className="section_title accent_mod height_mod offset_mod">{supportStreamSectionSection.title}</h2>
							<h3 className="section_subtitle accent_mod">{supportStreamSectionSection.subtitle}</h3>
							<div className="section_descr accent_mod height_mod">{supportStreamSectionSection.description}</div>
						</div>
					</div>
				</div>
			</section>
			<ConnectSection
				bgImg={connectSection.bgImage}
				title={connectSection.title}
				description={connectSection.description}
				buttonTitle={connectSection.buttonTitle}
				buttonUrl={connectSection.buttonUrl}
			/>
		</React.Fragment >

	);
}
export default Producers;